export const isEmpty = (val="") => { 
    return !!([undefined, null, ""].includes(val));
}

export const isEmptyAny = (vals = [""]) => { 
    if (Array.isArray(vals))
      return vals.some((val)=>([undefined, null, ""].includes(val)))
    else
        return true
}